import { render } from "./DeleteSvg.vue?vue&type=template&id=5d23bc04"
import script from "./DeleteSvg.vue?vue&type=script&lang=js"
export * from "./DeleteSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__